export type ProgressBubbleStatus = "active" | "completed" | "pending";

export interface ProgressBubbleItem {
  id: string;
  label: string;
  status: ProgressBubbleStatus;
  enabled?: boolean;
}

const getStatusLabel = (status: ProgressBubbleStatus) => {
  switch (status) {
    case "active":
      return "current";
    case "completed":
      return "completed";
    default:
      return "not started";
  }
};

export const ProgressBubbleBar = ({
  steps,
  ariaLabel,
  onStepClick,
}: {
  steps: ProgressBubbleItem[];
  ariaLabel: string;
  onStepClick?: (stepId: string) => void;
}) => (
  <div className="flex flex-wrap gap-x-3" role="list" aria-label={ariaLabel}>
    {steps.map((step) => {
      const isInteractive = !!onStepClick;
      const isEnabled = isInteractive && step.enabled !== false;
      const backgroundColor =
        step.status === "active"
          ? "bg-[#0089F9]"
          : step.status === "completed"
            ? "bg-[green]"
            : "bg-[gray]";

      return (
        <div
          key={step.id}
          id={step.id}
          data-testid={`step-${step.id}`}
          data-status={step.status}
          role="listitem"
          aria-current={step.status === "active" ? "step" : undefined}
          aria-label={`${step.label}: ${getStatusLabel(step.status)}`}
          className={`${isInteractive ? "group" : ""} ${
            isInteractive
              ? isEnabled
                ? "cursor-pointer"
                : "cursor-not-allowed"
              : "cursor-default"
          } py-2`}
          onClick={() => {
            if (isEnabled) {
              onStepClick(step.id);
            }
          }}
        >
          <div
            aria-hidden="true"
            className={`h-[10px] w-[30px] rounded-xl ${
              isEnabled ? "group-hover:opacity-80" : ""
            } ${backgroundColor}`}
          />
        </div>
      );
    })}
  </div>
);
